<template>
    <CCard>
        <CCardHeader>
            <strong>Действия</strong>
        </CCardHeader>
        <CCardBody v-if="statuses.length > 0">
            <p class="mb-3">Обновить статус заказа:</p>
            <span v-for="status in statuses" :key="status.status">
                <CButton
                    :style="orderStatusStyle(status.status)"
                    class="mr-3 mb-3"
                    @click="updateStatusModal(status.status)"
                >{{ orderStatusTitle(status.status) }}</CButton>
            </span>
            <p v-if="!adminOnly" class="mb-3">Другие действия:</p>
            <CButton
                v-if="!adminOnly"
                :color="order.delayed ? 'light' : 'warning'"
                class="mr-3 mb-3"
                @click="delayModal = true"
            >Отложить</CButton>
            <CButton
                v-if="!adminOnly"
                :color="order.pass === PASS_TYPE.NOT_PASSED ? 'danger' : (order.pass === PASS_TYPE.NOT_NEED ? 'light' : 'success')"
                :class="`${order.pass === PASS_TYPE.NOT_NEED ? 'not_need' : ''}`"
                class="mr-3 mb-3"
                @click="passModal = true"
            >Пропуск</CButton>
        </CCardBody>
        <CCardBody v-else>
            <p>Нет доступных действий.</p>
        </CCardBody>

        <CModal
            title="Изменение статуса заказа"
            :show.sync="newStatusModal"
            :footer="false"
            color="info"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow>
                            <CCol sm="4" class="form-group">ID заказа</CCol>
                            <CCol
                                sm="8"
                                class="form-group"
                            ><strong>#{{ id }}</strong></CCol
                            >
                        </CRow>
                        <CRow>
                            <CCol sm="4" class="form-group">Установить статус</CCol>
                            <CCol
                                sm="8"
                                class="form-group"
                            ><CBadge
                                :style="orderStatusStyle(newStatus)"
                            >&nbsp;{{ orderStatusTitle(newStatus) }}&nbsp;</CBadge
                            ></CCol
                            >
                        </CRow>
                        <CRow>
                            <CCol sm="12" class="form-group">Комментарий:</CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                sm="12"
                                class="form-group"
                            ><CTextarea v-model="comment" /></CCol>
                        </CRow>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="newStatusModal = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="updateStatusSubmit"
                    >Изменить статус</CButton
                    >
                </div>
            </template>
        </CModal>
        <CModal
            title="Отложить заказ"
            :show.sync="delayModal"
            :footer="false"
            color="info"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow class="pl-3 mb-1">Отложить до:</CRow>
                        <CRow>
                            <CCol>
                                <DatePicker
                                    v-model="datepicker.dateTo"
                                    :language="datepicker.lang"
                                    :format="datepicker.format"
                                    input-class="custom-datepicker"
                                    placeholder="Выберите дату..."
                                />
                            </CCol>
                            <CCol>
                                <CInput
                                    v-model="delayTime"
                                    class="m-0"
                                    type="time" />
                            </CCol>
                        </CRow>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="delayModal = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="stopDelay"
                    >Сбросить</CButton
                    >
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="setDelay"
                    >Отложить</CButton
                    >
                </div>
            </template>
        </CModal>
        <CModal
            title="Информация о пропуске"
            :show.sync="passModal"
            :footer="false"
            color="info"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="setPass(PASS_TYPE.PASSED)"
                    >Пропуск оформлен</CButton
                    >
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="setPass(PASS_TYPE.NOT_NEED)"
                    >Пропуск не требуется</CButton
                    >
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="newStatusModal = false"
                    >Отмена</CButton
                    >
                </div>
            </template>
        </CModal>
        <CModal
            v-if="adminOnly === 1"
            title="Изменение статуса заказа"
            :show.sync="newStatusAwaitng"
            :footer="false"
            color="info"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow>
                            <CCol sm="4" class="form-group">ID заказа:</CCol>
                            <CCol
                                sm="8"
                                class="form-group"
                            ><strong>#{{ id }}</strong></CCol
                            >
                        </CRow>
                        <CRow>
                            <CCol sm="4" class="form-group">Установить статус:</CCol>
                            <CCol
                                sm="8"
                                class="form-group"
                            ><CBadge
                                :style="orderStatusStyle(newStatus)"
                            >&nbsp;{{ orderStatusTitle(newStatus) }}&nbsp;</CBadge
                            ></CCol
                            >
                        </CRow>
                        <div slot="body-wrapper" class="form-group">
                            <CForm>
                                <CRow>
                                    <CCol>Время приготовления(мин):</CCol>
                                    <CCol
                                        sm="6"
                                        class="form-group">
                                        <CInput
                                            v-model="timeCooking"
                                            type="number"
                                            min="10"
                                            class="m-0"
                                            placeholder="Минуты"/>
                                    </CCol>
                                </CRow>
                            </CForm>
                        </div>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="newStatusAwaitng = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="updateStatusSubmitForAwaiting"
                    >Готовим</CButton
                    >
                </div>
            </template>
        </CModal>
    </CCard>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';
    import { orderStatusTitle, orderStatusStyle } from '../../utils/order-views';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';

    const { ORDER_STATUS, PASS_TYPE } = require('../../utils/order');

    export default {
        name: 'OrderActions',

        components: {
            DatePicker
        },

        props: {
            id: {
                type: Number,
                default: null
            },
            order: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                isAuthorized: false,
                PASS_TYPE,
                statuses: [],
                newStatus: null,
                comment: '',
                newStatusModal: false,
                newStatusAwaitng: false,
                delayModal: false,
                passModal: false,
                delayTime: '',
                timeCooking: '',
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateTo: null,
                },
            };
        },

        computed: {
            adminOnly() {
                return JSON.parse(localStorage.getItem('settings'))?.is_business_admin;
            },
        },
        
        watch: {},

        mounted() {
            Vue.axios
                .get('/orders/' + this.id + '/statuses')
                .then(resp => {
                    const avalibleStatuses = [ORDER_STATUS.AWAITING, ORDER_STATUS.AWAITING_READY, ORDER_STATUS.DELIVERY]
                    this.statuses = resp.data.filter(status => [ORDER_STATUS.PAYMENT_CORRECTION].indexOf(status.status) < 0);
                    if (this.adminOnly) {
                        this.statuses = this.statuses.filter(status => avalibleStatuses.includes(status.status));
                    }
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            orderStatusTitle(status) {
                if (this?.order?.ed?.items?.length) {
                    return orderStatusTitle(status, this.order.type, this.order.payment_type, this.order.ed.items[0].entity.statuses, this.order.delivery_type);
                }
                return orderStatusTitle(status, this.order.type, this.order.payment_type, null, this.order.delivery_type);
            },
            orderStatusStyle(status) {
                return orderStatusStyle(status, this.order.type, this.order.payment_type);
            },
            updateStatusModal(status) {
                this.newStatus = status;
                this.comment = '';
                this.timeCooking = '';
                if(+status === 3 && this.order.code === 'restaurant' && (this.adminOnly === 1) && this.order.rd && (this.order.rd.items[0].restaurant.time_cooking_request === true)){
                    this.newStatusAwaitng = true;
                } else  {
                    this.newStatusModal = true;
                }
            }, 
            updateStatusSubmit() {
                if (!this.id) {
                    this.$root.$emit('showError', 'Не указан ID заказа.');
                    return;
                }
                if (!this.newStatus) {
                    this.$root.$emit('showError', 'Не указан статус.');
                    return;
                }
                Vue.axios
                    .post('/orders/' + this.id + '/status', {
                        status: this.newStatus,
                        comment: this.comment,

                    })
                    .then(resp => {
                        location.reload();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Не получилось поменять статус. ');
                    });
            },
            updateStatusSubmitForAwaiting() {
                if (!this.id) {
                    this.$root.$emit('showError', 'Не указан ID заказа.');
                    return;
                }
                if (!this.newStatus) {
                    this.$root.$emit('showError', 'Не указан статус.');
                    return;
                }
                if (+this.timeCooking < 10) {
                    this.$root.$emit('showError', 'Время готовки не может быть меньше 10.');
                    return;
                } else if (isNaN(+this.timeCooking)) {
                    this.$root.$emit('showError', 'Укажите время готовки (в минутах).');
                    return;
                }
                Vue.axios
                    .post('/orders/' + this.id + '/status', {
                        status: this.newStatus,
                        comment: this.comment,
                        time_cooking: this.timeCooking,
                    })
                    .then(resp => {
                        location.reload();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Не получилось поменять статус. ');
                    });
            },
            setDelay() {
                if (!this.id) {
                    this.$root.$emit('showError', 'Не указан ID заказа.');
                    return;
                }
                if (!this.delayTime) {
                    this.$root.$emit('showError', 'Укажите время.');
                    return;
                }
                if (!this.datepicker.dateTo) {
                    this.$root.$emit('showError', 'Укажите дату.');
                    return;
                }
                Vue.axios
                    .post(`/orders/${this.id}/delay`, {
                        delayed: true,
                        delay_time: moment(`${this.datepicker.dateTo.toLocaleDateString()} ${this.delayTime}`, 'DD.MM.YYYY HH:mm')
                            .format('YYYY-MM-DD HH:mm:ss'),
                    })
                    .then(resp => {
                        location.reload();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Не получилось отложить заказ.');
                    });
            },
            stopDelay() {
                if (!this.id) {
                    this.$root.$emit('showError', 'Не указан ID заказа.');
                    return;
                }
                Vue.axios
                    .post(`/orders/${this.id}/delay`, {
                        delayed: false,
                        delay_time: null,
                    })
                    .then(resp => {
                        location.reload();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Не получилось сбросить. ' + err);
                    });
            },
            setPass(pass) {
                if (!this.id) {
                    this.$root.$emit('showError', 'Не указан ID заказа.');
                    return;
                }
                Vue.axios
                    .post(`/orders/${this.id}/pass`, { pass })
                    .then(() => {
                        location.reload();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка установки пропуска. ' + err);
                    });
            },
        },
    };
</script>

<style>
input.custom-datepicker {
    border: 1px solid;
    border-color: #d8dbe0;
    width: 100%;
    height: 35px;
    border-radius: 5px;
    padding-left: 10px;
}
</style>
<style scoped>
.not_need {
    border: 2px solid #68CE85;
}
</style>
